import type { ModelProperty, NodePropertyName, ViewConfigSorter } from '@salescore/core'

import { isSameNodeProperty } from '../../../recoil/view/mutations/field/util'

// ヘッダーの昇順/降順は「並び順（order）だけを変える」操作なので、同一 property の並び替えが既にあるなら
// その sortBy を維持する。sortBy 欠損のレガシー sorter は ID ソート（value）として復元する。
// 参照列の既定 label は、その property にまだ sorter が無い新規時のみ適用する（既存の value 指定を label に
// 上書きしないため）。同一 property の判定は upsertSorter 側の置換キー（isSameNodeProperty）と揃える。
//
// 参照項目かどうかは referenceTo の有無で判定する。ViewQueryField.meta.fieldMetaType は property.meta の
// 素通しで、コネクタによっては参照項目でも 'relation' にならない一方、表示名 SQL（labelSql）の生成は
// referenceTo を起点に行うため、fieldMetaType で判定すると並び替えモーダル側（referenceTo 非空で 2 エントリ化）
// と食い違い、ヘッダー経路だけ表示名ソート可能な列を取りこぼす。
export const resolveHeaderSorterSortBy = ({
  sorters,
  property,
  modelProperty,
}: {
  sorters: ViewConfigSorter[] | undefined
  property: NodePropertyName | undefined
  modelProperty: Pick<ModelProperty, 'referenceTo'> | undefined
}): 'value' | 'label' => {
  const existingSorter =
    property === undefined ? undefined : (sorters ?? []).find((sorter) => isSameNodeProperty(sorter.property, property))
  if (existingSorter !== undefined) {
    return existingSorter.sortBy ?? 'value'
  }
  return (modelProperty?.referenceTo ?? []).length > 0 ? 'label' : 'value'
}
